import Vue from 'vue'
import Router from 'vue-router'
import AppWrapper from '@/components/pages/appWrapper'
import Login from '@/components/pages/login'
import NotFound from '@/components/pages/notFound'

import Users from '@/components/pages/users/users'
import UserForm from '@/components/pages/users/userForm'
import Teams from '@/components/pages/teams/teams'
import TeamForm from '@/components/pages/teams/teamForm'
import Players from '@/components/pages/players/players'
import PlayerForm from '@/components/pages/players/playerForm'
import Fields from '@/components/pages/fields/fields'
import FieldForm from '@/components/pages/fields/fieldForm'
import Complexes from '@/components/pages/complexes/complexes'
import ComplexForm from '@/components/pages/complexes/complexForm'
import Tournaments from '@/components/pages/tournaments/tournaments'
import TournamentForm from '@/components/pages/tournaments/tournamentForm'
import Requests from '@/components/pages/requests/requests'
import Partnering from '@/components/pages/partnering/partnering'
import TournamentRegistrationForm from '@/components/pages/tournaments/tournament_registration/tournamentRegistrationForm'
import TournamentRegistrations from '@/components/pages/tournaments/tournament_registration/tournamentRegistrations'
import TournamentsRegistrationsStatistics from '@/components/pages/statistics/tournamentsRegistrationsStatistics'
import Iframe from '@/components/pages/iframe/iframe'
import Notifications from '@/components/pages/notifications/notifications'
import Sponsorships from '@/components/pages/sponsorships/sponsorships'
import SponsorshipForm from '@/components/pages/sponsorships/sponsorshipForm'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: AppWrapper,
      children:[
        {
          path: '/users',
          name: 'userslist',
          component: Users
        },
        {
          path: '/users/new',
          name: 'usernewform',
          component: UserForm
        },
        {
          path: '/users/edit/:userID',
          name: 'usereditform',
          component: UserForm,
          props: true
        },
        {
          path: '/teams',
          name: 'teamslist',
          component: Teams
        },
        {
          path: '/teams/new',
          name: 'teamnewform',
          component: TeamForm
        },
        {
          path: '/teams/edit/:teamID',
          name: 'teameditform',
          component: TeamForm,
          props: true
        },
        {
          path: '/players',
          name: 'playerslist',
          component: Players
        },
        {
          path: '/players/new',
          name: 'playernewform',
          component: PlayerForm
        },
        {
          path: '/players/edit/:playerID',
          name: 'playereditform',
          component: PlayerForm
        },
        {
          path: '/fields',
          name: 'fieldslist',
          component: Fields
        },
        {
          path: '/fields/new',
          name: 'fieldnewform',
          component: FieldForm
        },
        {
          path: '/fields/edit/:id',
          name: 'fieldeditform',
          component: FieldForm,
          props: true
        },
        {
          path: '/complexes',
          name: 'complexeslist',
          component: Complexes
        },{
          path: '/complexes/new',
          name: 'complexnewform',
          component: ComplexForm
        },
        {
          path: '/complexes/edit/:complexID',
          name: 'complexeditform',
          component: ComplexForm,
          props: true
        },
        {
          path: '/tournaments',
          name: 'tournamentslist',
          component: Tournaments
        },
        {
          path: '/tournaments/new',
          name: 'tournamentform',
          component: TournamentForm
        },
        {
          path: '/tournaments/edit/:tournamentID',
          name: 'tournamenteditform',
          component: TournamentForm,
          props: true
        },
        {
          path: '/tournaments/:tournamentID/registrations',
          name: 'tournamentregistrations',
          component: TournamentRegistrations,
          props: true
        },
        {
          path: '/requests',
          name: 'requestes',
          component: Requests
        },
        {
          path: '/requests/partnering',
          name: 'partnering',
          component: Partnering
        },{
          path: '/registrations-statistics',
          name: 'registrationsstatistics',
          component : TournamentsRegistrationsStatistics
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: Notifications
        },
        {
          path: '/sponsorships',
          name: 'sponsorships',
          component: Sponsorships
        },
        {
          path: '/sponsorship/detail/:id',
          name: 'editsponsorship',
          component: SponsorshipForm,
          props: true
        },
        {
          path: '/sponsorships/new',
          name: 'sponsorshipsform',
          component: SponsorshipForm
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login

    },
    {
      path: '/:lang/tournament-registration/:tournamentID',
      name: 'tournamentregistration',
      props: true,
      component: TournamentRegistrationForm

    },
    {
      path: '/iframe/tournament/:tournamentID',
      name: 'iframe',
      props: true,
      component: Iframe

    },

    {
      path: '/not-found',
      name: '404',
      component : NotFound
    },
    {
      path: '*',
      redirect: {name: '404'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js